module.exports = __webpack_public_path__ + "static/media/investments_logo.b01000ae.jpg";